<template>
  <div class="layoutDefault" style="margin-top: 2rem">
    <div class="grid grid-cols-1 gap-4">
      <div class="z-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div
          class="flex cursor-pointer rounded-lg py-2 items-center"
          style="width: 230px"
          @click="$router.go(-1)"
        >
          <IconArrow
            class="mr-3 mt-1 stroke-current text-habu h-6 w-6 stroke-2 transform rotate-0"
          />
          <span class="text-2xl text-normal">Certificate List</span>
        </div>

        <div class="flex justify-end gap-3 relative z-50">
          <div class="form-filter relative w-full sm:w-auto">
            <input
              type="text"
              class="input w-full sm:w-auto"
              placeholder="Type something here..."
              style="padding-right: 36px"
              v-model="filter"
            />
            <div class="absolute right-0 inset-y-0 flex items-center">
              <SvgSearch class="mr-2 mb-1.5" />
            </div>
          </div>

          <div class="form-filter relative w-28">
            <treeselect
              :multiple="false"
              class="h-9"
              v-model="year"
              :options="years"
              placeholder="Year"
              instanceId="year"
            />
          </div>
        </div>
      </div>

      <div class="hcard relative z-5 p-5 sm:p-7" v-if="loading">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-5 mt-2 animate-pulse">
          <div class="relative" v-for="b in 4" :key="b">
            <div class="hcard-b17 flex flex-col p-5 h-full">
              <div class="flex-grow">
                <div class="grid-cols-1 mb-7">
                  <div class="h-6 w-32 bg-hline rounded-lg"></div>

                  <div class="h-0.5 w-full my-3 bg-hline rounded-lg"></div>

                  <div class="h-5 w-68 bg-hline rounded-lg"></div>
                  <div class="h-5 w-56 mt-1 bg-hline rounded-lg"></div>
                  <div class="h-5 w-60 mt-1 bg-hline rounded-lg"></div>
                  <div class="h-5 w-28 mt-1 bg-hline rounded-lg"></div>
                  <div class="h-5 w-38 mt-1 bg-hline rounded-lg"></div>
                </div>
              </div>
              <div class="flex justify-between">
                <div class="">
                  <div class="h-7 w-24 bg-hline rounded-lg"></div>
                </div>
                <div class="relative">
                  <div class="h-5 w-28 bg-hline rounded-lg"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hcard relative z-5 p-3 sm:p-7" v-else>
        <div class="grid mb-8 px-3" v-if="$route.query.instrument_id">
          <div class="flex mt-1 mb-1">
            <div class="mr-4 pt-0.5">
              <SvgInstrumentXs class="w-5 h-5" />
            </div>
            <p class="text-lg font-semibold font-Roboto text-htext">Instrument</p>
          </div>

          <div class="text-32px font-medium" v-if="certificates">
            SN:
            {{
              certificates[0].instrument_detail
                ? certificates[0].instrument_detail.serial_number
                : '-'
            }}
          </div>
          <div class="text-32px mt-1" v-if="certificates">
            {{
              certificates[0].instrument_detail
                ? certificates[0].instrument_detail.contract_type
                : '-'
            }}
            -
            {{ certificates[0].instrument_detail ? certificates[0].instrument_detail.type : '-' }}
          </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div class="col-span-2 py-24" v-if="!certificates.length">
            <img :src="NoData" class="mx-auto" />
            <div class="capitalize font-semibold text-5xl text-hblue text-center">
              there is no certificate yet!
            </div>
          </div>

          <div
            class="hcard-cert hover:bg-hgray6 cursor-pointer w-full"
            v-for="b in certificates"
            :key="b.id"
            @click="openMenu(b)"
          >
            <img :src="BgCert" class="absolute right-0 top-0 rounded-tr-28px" />

            <div class="flex flex-col py-5 h-full z-1 relative">
              <div class="flex-grow">
                <div class="grid-cols-1 mb-7">
                  <div class="font-semibold text-htext text-xl pl-7 z-10">
                    {{ b.certificate }}
                  </div>
                  <div
                    class="bg-hwarning text-white font-Roboto text-sm py-1 pl-7 pr-2 rounded-r-full max-w-65p mt-1.5"
                  >
                    {{ b.number }}
                  </div>
                  <div class="font-Roboto text-xs pl-7 mt-1">
                    <span class="text-black">Which was held on </span>
                    <span class="text-htext font-semibold">
                      {{ b.issued_date | moment('DD MMMM YYYY') }}
                    </span>
                  </div>

                  <div class="pl-14 mt-5">
                    <div class="text-xs text-black font-semibold">Instrument :</div>
                    <div class="text-xl text-htext font-semibold">
                      {{ b.instrument_detail ? b.instrument_detail.type : '' }} (S/N :
                      {{ b.instrument_detail ? b.instrument_detail.serial_number : '' }})
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex justify-between content-end px-7">
                <div class="relative">
                  <div class="text-xs font-Roboto font-medium">Approved by:</div>
                  <div class="text-htext font-semibold">{{ b.approved_name }}</div>
                  <div class="text-xs font-Roboto font-medium">
                    {{ b.approved_position }}
                  </div>
                </div>
                <div class="relative">
                  <div class="text-xs font-Roboto font-medium">Expired date:</div>
                  <div class="text-xs text-htext font-semibold font-Roboto">
                    {{ b.expired_date | moment('DD MMMM YYYY') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="flex justify-between space-x-2 mx-auto mt-8 text-center"
          style="max-width: 100px"
        >
          <button
            class="btn font-semibold bg-hteal1 hover:bg-hteal1 rounded-full btn-sm border-0"
            :disabled="currentPage == 1"
            @click="pageDecrease"
          >
            «
          </button>
          <button
            class="btn font-semibold rounded-full btn-sm btn-ghost no-animation hover:border-transparent"
          >
            {{ currentPage }}
          </button>
          <button
            class="btn font-semibold bg-hteal1 hover:bg-hteal1 rounded-full btn-sm border-0"
            :disabled="currentPage == totalPage"
            @click="pageIncrease"
          >
            »
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconArrow from '@/assets/icons/icon-arrow.svg?inline'
import SvgInstrumentXs from '@/assets/icons/icon-instrument.svg?inline'
import SvgSearch from '@/assets/icons/icon-search.svg?inline'

import NoData from '@/assets/images/icon-noCertificate.png'
import BgCert from '@/assets/images/bg-cert.png'
import Treeselect from '@riophae/vue-treeselect'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'certifcates',
  components: {
    IconArrow,
    SvgInstrumentXs,
    Treeselect,
    SvgSearch
  },
  data() {
    return {
      NoData,
      BgCert,
      filter: '',
      loading: true,
      currentPage: 1,
      totalPage: 1,
      year: new Date().getFullYear()
    }
  },
  computed: {
    ...mapState({
      certificates: state => state.instrument.certificates
    }),
    years() {
      const currentYear = new Date().getFullYear()
      let yearsList = []
      for (let i = 2016; i <= currentYear; i++) {
        yearsList.push({
          id: i,
          label: i
        })
      }
      return yearsList.sort((a, b) => b.id - a.id)
    }
  },
  watch: {
    '$route.query': {
      deep: true,
      immediate: true,
      handler() {
        this.getData()
      }
    },
    filter: function () {
      this.changePage(1)
    },
    year: function () {
      this.changePage(1)
    }
  },
  methods: {
    ...mapActions('instrument', ['GET_CERTIFICATES', 'GET_CERTIFICATE']),
    ...mapActions('modal', ['MODAL_CERTIFICATE']),
    async getData() {
      this.loading = true

      let queries = JSON.parse(JSON.stringify(this.$route.query))

      queries.search = this.filter

      if (this.year) {
        queries.year = this.year
      }

      let res = await this.GET_CERTIFICATES(queries)

      if (res && res.pagination) {
        this.totalPage = res.pagination.total_pages
      }
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    pageDecrease() {
      if (this.currentPage > 1) {
        this.currentPage -= 1
        this.changePage(this.currentPage)
      }
    },
    pageIncrease() {
      if (this.currentPage < this.totalPage) {
        this.currentPage += 1
        this.changePage(this.currentPage)
      }
    },
    changePage(val) {
      // let offset = (val - 1) * 4
      let queries = JSON.parse(JSON.stringify(this.$route.query))
      queries.t = new Date().getTime()
      // queries.offset = offset
      queries.limit = 6
      queries.page = val

      this.$router.replace({ query: queries })
    },
    openMenu(val) {
      this.MODAL_CERTIFICATE(val)
    }
  }
}
</script>
